// app/components/EnglishLevelCard.jsx
import React from 'react'
import { PolarArea } from 'react-chartjs-2'
import Chart from 'chart.js/auto'

const FrenchLevelCard = ({ levels }) => {
  const labels = levels.map((item) => item.level)
  const total = levels.map((item) => item.total)

  const data = {
    labels: labels,
    datasets: [
      {
        data: total,
        backgroundColor: [
          'rgba(255,99,132,0.2)',
          'rgba(54,162,235,0.2)',
          'rgba(255,206,86,0.2)',
          'rgba(75,192,192,0.2)',
        ],
      },
    ],
  }

  const options = {
    plugins: {
      legend: {
        display: true,
        position: 'bottom',
        align: 'start', // Align to the start (left)
        labels: {
          padding: 10, // Adjust padding as needed
          boxWidth: 10, // Adjust the box size of the legend
        },
      },
    },
  }

  return (
    <div className="bg-white p-4 lg:p-12 rounded-[40px] tl-shadow">
      <h2 className="text-lg font-semibold mb-6">Levels of French</h2>
      <PolarArea data={data} options={options} />
    </div>
  )
}

export default FrenchLevelCard
